export default function HotjarScript() {
  return (
    <>
      <script src="https://t.contentsquare.net/uxa/dc82cd7c704e7.js" defer></script>
    </>
  );
}
